import React from "react";

type Props = {
  // you can adjust skeleton height 
  className?: string;
};

export const TextSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <div className="mx-auto w-full max-w-sm rounded-md shadow">
      <div className="flex animate-pulse space-x-4">
        <div className="flex-1">
          <div className={`h-8 rounded bg-slate-200 ${className}`}></div>
        </div>
      </div>
    </div>
  );
};
